import React from 'react';
import InviteForInterviewConfirm from './InviteForInterviewConfirm';
import InviteForInterviewDialog from './InviteForInterviewDialog';
import RejectDialog from './RejectDialog';
import HireDialog from './HireDialog';
import TableAssessmentResetDialog from './TableAssessmentResetDialog';

interface DialogsProps {
    assessmentName: string;
}

function Dialogs({ assessmentName }: DialogsProps): React.JSX.Element {
    return (
        <>
            <RejectDialog assessmentName={assessmentName} />
            <InviteForInterviewDialog assessmentName={assessmentName} />
            <InviteForInterviewConfirm />
            <HireDialog />
            <TableAssessmentResetDialog />
        </>
    );
}

export default Dialogs;
